import Check from '@mui/icons-material/Check'
import EditOutlined from '@mui/icons-material/EditOutlined'
import { IconButton, Stack, Tooltip, Typography } from '@mui/material'
import type { TemplateManual } from '@ulysses-inc/harami_api_client'
import type { FC } from 'react'
import { useState } from 'react'
import EditManualModal from './EditManualModal'

interface OwnProps {
  manual: TemplateManual
}

const EditManualBlocks: FC<OwnProps> = ({ manual }) => {
  const [isOpenEditManual, setIsOpenEditManual] = useState(false)

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      data-testid="manual-content-cell"
    >
      <Tooltip title="マニュアルを編集">
        <IconButton
          onClick={() => setIsOpenEditManual(true)}
          aria-label="マニュアルを編集"
          color="primary"
        >
          <EditOutlined color="primary" />
        </IconButton>
      </Tooltip>
      {(manual.blocks ?? []).length > 0 && (
        <Stack
          direction="row"
          alignItems="center"
          spacing={0.625}
          sx={{ color: 'success.main' }}
        >
          <Check fontSize="small" />
          <Typography variant="body2">入力済</Typography>
        </Stack>
      )}
      <EditManualModal
        templateManual={manual}
        isOpenModal={isOpenEditManual}
        setIsOpenModal={setIsOpenEditManual}
        onClose={() => setIsOpenEditManual(false)}
        blocks={manual.blocks}
      />
    </Stack>
  )
}

export default EditManualBlocks
